import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LogoImg from './images/logo.jpg'
import QrImg from './images/qr_zoc.jpg'

import casesData from './cases.json';
import './styles/main.css'

// 七牛云图片OSS
const cdnPath = 'http://img.zocdesign.net/cases-dev/'


// 文件名模板：
// ux_0_seg13.jpg  |   ux_thumb_0.jpg  |  ux_thumb_hero_0.jpg
// mk_2_seg8.jpg  |  mk_thumb_2.jpg  |  mk_thumb_hero_2.jpg
// bak:{ "id": 9, "type": "ux", "name": "华福小福牛5.0", "brand": "华福证券", "segNum": 9 },


// 从json中读取案例信息
const cases_raw: CaseInput[] = casesData.cases_raw as CaseInput[];
const caseGridOrder = casesData.caseGridOrder;


// 根据案例信息，构建案例对象，用于heors和grids
let caseRenderObjs: CaseRenderObjs = { ux: [], mk: [] }
for (let c of cases_raw) {
  caseRenderObjs[c.type].push({
    id: c.id,
    type: c.type,
    name: c.name,
    brand: c.brand,
    thumb: cdnPath + `${c.type}_thumb_${c.id}.jpg`,
    main: cdnPath + `${c.type}_${c.id}_seg`,
    segNum: c.segNum,
    isHero: c.isHero,
    heroThumb: c.isHero ? cdnPath + `${c.type}_thumb_hero_${c.id}.jpg` : ''
  })
}

// 构建Heros
const heros = {
  ux: caseRenderObjs.ux.filter(c => c.isHero)[0],
  mk: caseRenderObjs.mk.filter(c => c.isHero)[0]
}




// 根据caseGridOrder来排序ux和mk类型的案例
const uxGrid = caseRenderObjs.ux.sort((a, b) => caseGridOrder.ux.indexOf(a.id) - caseGridOrder.ux.indexOf(b.id)).filter(obj => !obj.isHero);
const mkGrid = caseRenderObjs.mk.sort((a, b) => caseGridOrder.mk.indexOf(a.id) - caseGridOrder.mk.indexOf(b.id)).filter(obj => !obj.isHero);



const App = () => {
  const navigate = useNavigate();
  const [caseView, setCaseView] = useState('info')

  React.useEffect(() => {
    // 初始化选中的Tab
    const initViewStorage = localStorage.getItem('indexView')

    if (initViewStorage === null || initViewStorage === '') {
      localStorage.setItem('indexView', 'info')
    } else {
      setCaseView(initViewStorage)
    }
  }, [])

  if (typeof window === `undefined`) { return <></> }


  function setView(str: string) {
    setCaseView(str)
    localStorage.setItem('indexView', str)
  }

  return (
    <div className='page'>
      {/* ====== SIDE:START ====== */}
      <div className='case-side'>
        <div className='case-title'>
          <img src={LogoImg} width={205} className='logo' alt='logo'></img>
        </div>
        <div className='case-tab'>
          <button className={caseView === 'info' ? 'btnActive' : 'none'} onClick={() => { setView('info') }}>关于卓奇</button>
          <button className={caseView === 'ux' ? 'btnActive' : 'none'} onClick={() => { setView('ux') }}>产品UX</button>
          <button className={caseView === 'mk' ? 'btnActive' : 'none'} onClick={() => { setView('mk') }}>专题营销</button>
        </div>
        <div className='side-qr'>
          <img src={QrImg} alt='ZOC.D公众号' width={150}></img>
          <p>扫码关注卓奇咨询官方微信公众号</p>
        </div>
        <div className='side-icp'>
          ICP证：<a href='https://beian.miit.gov.cn' target='_blank' rel='noreferrer'>苏ICP备13009085号-3</a>
        </div>
      </div>
      {/* ====== SIDE:END ====== */}

      {/* ====== CONTENT:START ====== */}
      <div className='case-list-assemble'>
        {/* ZOC section */}
        <div className='case-list-body' style={{ display: caseView === 'info' ? 'grid' : 'none' }}>
          <div style={{ borderRadius: '12px', fontSize: 0, overflow: 'hidden' }}>
            <img src={`${cdnPath}intro1.jpg`} alt='' width='1000' />
            <img src={`${cdnPath}intro2.jpg`} alt='' width='1000' />
            <img src={`${cdnPath}intro3.jpg`} alt='' width='1000' />
            <img src={`${cdnPath}intro4.jpg`} alt='' width='1000' />
          </div>
        </div>

        {/* UX section */}
        <div className='case-list-body' style={{ display: caseView === 'ux' ? 'grid' : 'none' }}>
          <div className='case-hero'>
            {/* UX Hero */}
            <div className='link' onClick={() => navigate('/single/', { state: { caseObj: heros.ux } })} >
              <img src={heros.ux.heroThumb} alt='' width='1000' height='380' />
            </div>
          </div>
          <div className='case-grid'>
            {uxGrid.map(
              (c, id) => <CaseThumb caseObj={c} key={id} />
            )}
          </div>
        </div>

        {/* Marketing section */}
        <div className='case-list-body' style={{ display: caseView === 'mk' ? 'grid' : 'none' }}>
          <div className='case-hero'>
            <div className='link' onClick={() => navigate('/single/', { state: { caseObj: heros.mk } })}>
              <img src={heros.mk.heroThumb} alt='' width='1000' height='380' />
            </div>
          </div>
          <div className='case-grid'>
            {mkGrid.map(
              (c, id) => <CaseThumb caseObj={c} key={id} />
            )}
          </div>
        </div>
      </div>
      {/* ====== CONTENT:END ====== */}
    </div>
  )
}




const CaseThumb = ({ caseObj }: { caseObj: CaseRenderObj }) => {
  let navigate = useNavigate();
  return (
    <div className='case-block link' onClick={() => navigate('/single/', { state: { caseObj: caseObj } })}>

      <div style={{ display: "grid" }}>
        <div className='case-block-img'>
          <img src={caseObj.thumb} alt={caseObj.name.toString()} width='315' height='210' />
        </div>
      </div>

    </div>
  )
}

export default App
